export default __webpack_public_path__ + "static/media/logo.de13d484.png";